export const ACCOUNT_TYPE = {
    CHECKING: 'Checking',
    SAVINGS: 'Savings',
    CREDIT_CARD: 'Credit Card',
    LINE_OF_CREDIT: 'Line of Credit',
    LOAN: 'Loan',
    MORTGAGE: 'Mortgage',
    STUDENT_LOAN: 'Student Loan',
    INVESTMENT: 'Investment',
    OTHER: 'Other',
}

export const OB_ACCOUNT_TYPE = {
    "checking": {
        description: "Standard checking",
        mapping: ACCOUNT_TYPE.CHECKING
    },
    "savings": {
        description: "Standard savings",
        mapping: ACCOUNT_TYPE.SAVINGS
    },
    "cd": {
        description: "Certificates of deposit",
        mapping: ACCOUNT_TYPE.SAVINGS
    },
    "moneyMarket": {
        description: "Money Market",
        mapping: ACCOUNT_TYPE.INVESTMENT
    },
    "creditCard": {
        description: "Standard credit cards",
        mapping: ACCOUNT_TYPE.CREDIT_CARD
    },
    "lineOfCredit": {
        description: "Home equity, line of credit",
        mapping: ACCOUNT_TYPE.LINE_OF_CREDIT
    },
    "investment": {
        description: "Generic investment (no details)",
        mapping: ACCOUNT_TYPE.INVESTMENT
    },
    "investmentTaxDeferred": {
        description: "Generic tax-advantaged investment (no details)",
        mapping: ACCOUNT_TYPE.INVESTMENT
    },
    "employeeStockPurchasePlan": {
        description: "ESPP, Employee Stock Ownership Plans (ESOP), Stock Purchase Plans",
        mapping: ACCOUNT_TYPE.INVESTMENT
    },
    "ira": {
        description: "Individual Retirement Account (not Rollover or Roth)",
        mapping: ACCOUNT_TYPE.INVESTMENT
    },
    "401k": {
        description: "401K Plan",
        mapping: ACCOUNT_TYPE.INVESTMENT
    },
    "roth": {
        description: "Roth IRA, Roth 401K",
        mapping: ACCOUNT_TYPE.INVESTMENT
    },
    "403b": {
        description: "403B Plan",
        mapping: ACCOUNT_TYPE.INVESTMENT
    },
    "529plan": {
        description: "529 Plan (True value is 529)",
        mapping: ACCOUNT_TYPE.INVESTMENT
    },
    "rollover": {
        description: "Rollover IRA",
        mapping: ACCOUNT_TYPE.INVESTMENT
    },
    "ugma": {
        description: "Uniform Gifts to Minors Act",
        mapping: ACCOUNT_TYPE.INVESTMENT
    },
    "utma": {
        description: "Uniform Transfers to Minors Act",
        mapping: ACCOUNT_TYPE.INVESTMENT
    },
    "keogh": {
        description: "Keogh Plan",
        mapping: ACCOUNT_TYPE.INVESTMENT
    },
    "457plan": {
        description: "457 Plan (True value is 457)",
        mapping: ACCOUNT_TYPE.INVESTMENT
    },
    "401a": {
        description: "401A Plan",
        mapping: ACCOUNT_TYPE.INVESTMENT
    },
    "brokerageAccount": {
        description: "Brokerage Account",
        mapping: ACCOUNT_TYPE.INVESTMENT
    },
    "educationSavings": {
        description: "Education Savings Account that is not a 529",
        mapping: ACCOUNT_TYPE.INVESTMENT
    },
    "healthSavingsAccount": {
        description: "HSA (Health Savings Accounts)",
        mapping: ACCOUNT_TYPE.INVESTMENT
    },
    "pension": {
        description: "Pension",
        mapping: ACCOUNT_TYPE.INVESTMENT
    },
    "profitSharingPlan": {
        description: "Profit Sharing Plan",
        mapping: ACCOUNT_TYPE.INVESTMENT
    },
    "roth401k": {
        description: "Roth 401K",
        mapping: ACCOUNT_TYPE.INVESTMENT
    },
    "sepIRA": {
        description: "Simplified Employee Pension IRA",
        mapping: ACCOUNT_TYPE.INVESTMENT
    },
    "simpleIRA": {
        description: "Simple IRA",
        mapping: ACCOUNT_TYPE.INVESTMENT
    },
    "thriftSavingsPlan": {
        description: "Thrift Savings Plan",
        mapping: ACCOUNT_TYPE.INVESTMENT
    },
    "variableAnnuity": {
        description: "Variable Annuity",
        mapping: ACCOUNT_TYPE.INVESTMENT
    },
    "cryptocurrency": {
        description: "Cryptocurrency Wallet, Cryptocurrency Account",
        mapping: ACCOUNT_TYPE.INVESTMENT
    },
    "mortgage": {
        description: "Standard Mortgages",
        mapping: ACCOUNT_TYPE.MORTGAGE
    },
    "loan": {
        description: "Auto loans, equity loans, other loans",
        mapping: ACCOUNT_TYPE.LOAN
    },
    "studentLoan": {
        description: "Student Loan",
        mapping: ACCOUNT_TYPE.STUDENT_LOAN
    },
    "studentLoanGroup": {
        description: "Student Loan Group",
        mapping: ACCOUNT_TYPE.STUDENT_LOAN
    },
    "studentLoanAccount": {
        description: "Student Loan Account",
        mapping: ACCOUNT_TYPE.STUDENT_LOAN
    },
}

export const PLAID_ACCOUNT_TYPE = {
    "depository": {
        description: "Depository account",
        mapping: ACCOUNT_TYPE.CHECKING
    },
    "credit": {
        description: "Credit card account",
        mapping: ACCOUNT_TYPE.CREDIT_CARD
    },
    "loan": {
        description: "Loan account",
        mapping: ACCOUNT_TYPE.LOAN
    },
    "mortgage": {
        description: "Mortgage account",
        mapping: ACCOUNT_TYPE.MORTGAGE
    },
    "student": {
        description: "Student loan account",
        mapping: ACCOUNT_TYPE.STUDENT_LOAN
    },
    "investment": {
        description: "Investment account",
        mapping: ACCOUNT_TYPE.INVESTMENT
    },
    "other": {
        description: "Other account",
        mapping: ACCOUNT_TYPE.OTHER
    }
}

export const ACCOUNT_TYPE_LIST = [
    ACCOUNT_TYPE.CHECKING,
    ACCOUNT_TYPE.SAVINGS,
    ACCOUNT_TYPE.CREDIT_CARD,
    ACCOUNT_TYPE.LINE_OF_CREDIT,
    ACCOUNT_TYPE.LOAN,
    ACCOUNT_TYPE.MORTGAGE,
    ACCOUNT_TYPE.STUDENT_LOAN,
    ACCOUNT_TYPE.INVESTMENT,
    ACCOUNT_TYPE.OTHER
]

export const isDebt = (accountType) => {
    return (
        accountType === ACCOUNT_TYPE.CREDIT_CARD ||
        accountType === ACCOUNT_TYPE.LINE_OF_CREDIT ||
        accountType === ACCOUNT_TYPE.LOAN ||
        accountType === ACCOUNT_TYPE.MORTGAGE ||
        accountType === ACCOUNT_TYPE.STUDENT_LOAN
    )
}

export const isLoan = (accountType) => {
    return (
        accountType === ACCOUNT_TYPE.LOAN ||
        accountType === ACCOUNT_TYPE.MORTGAGE ||
        accountType === ACCOUNT_TYPE.STUDENT_LOAN
    )
}

export default ACCOUNT_TYPE;